import React from 'react';

const Accountability = ({ people }) => {
    return (
        <div className="bg-white rounded-2xl p-6 shadow-md flex flex-col h-full">
            <h3 className="text-sm font-bold text-gray-900 mb-4">Accountability</h3>

            <div className="flex flex-col gap-4 overflow-y-auto pr-1 min-h-[100px] max-h-[340px]">
                {people?.length > 0 ? (
                    people.map((person) => (
                        <div key={person.id} className="bg-[#E5E7EB] rounded-lg p-3 flex items-center gap-3 relative">
                            <div className="w-10 h-10 rounded-full bg-[#1F4B55] flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
                                {person.initials}
                            </div>
                            <div className="flex flex-col">
                                <span className="text-xs text-gray-600 font-medium">{person.role}</span>
                                <span className="text-xs font-bold text-gray-900">{person.name}</span>
                            </div>

                            <div className="ml-auto flex flex-col items-end">
                                <div className="text-[10px] text-gray-900 mb-0.5">
                                    {person.tasksCompleted}/{person.totalTasks} tasks
                                </div>
                                <div className="flex items-center gap-1">
                                    <span className="text-xs font-bold text-gray-900">{person.percentage}%</span>
                                    <span className="bg-[#FF7676] text-white text-[10px] font-bold px-1.5 rounded">{person.delayed}</span>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="flex flex-col items-center justify-center py-8 px-4">
                        {/* Icon */}
                        <div className="w-16 h-16 mb-4 rounded-full bg-gradient-to-br from-orange-50 to-amber-50 flex items-center justify-center">
                            <svg
                                className="w-8 h-8 text-orange-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                                />
                            </svg>
                        </div>

                        {/* Main Message */}
                        <h4 className="text-gray-900 font-semibold text-base mb-2">
                            No Team Data
                        </h4>

                        {/* Descriptive Text */}
                        <p className="text-gray-500 text-sm text-center max-w-xs">
                            Team member accountability metrics will be shown here once tasks are assigned and tracked.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Accountability;
